"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ThemeSpacingEnum;
(function (ThemeSpacingEnum) {
    ThemeSpacingEnum["space25"] = "space25";
    ThemeSpacingEnum["space50"] = "space50";
    ThemeSpacingEnum["space75"] = "space75";
    ThemeSpacingEnum["space100"] = "space100";
    ThemeSpacingEnum["space125"] = "space125";
    ThemeSpacingEnum["space150"] = "space150";
    ThemeSpacingEnum["space200"] = "space200";
    ThemeSpacingEnum["space250"] = "space250";
    ThemeSpacingEnum["space300"] = "space300";
    ThemeSpacingEnum["space400"] = "space400";
    ThemeSpacingEnum["space550"] = "space550";
    ThemeSpacingEnum["space750"] = "space750";
})(ThemeSpacingEnum || (ThemeSpacingEnum = {}));
exports.default = ThemeSpacingEnum;
//# sourceMappingURL=ThemeSpacingEnum.js.map